import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class VoucherMessageChannelUserForm extends CerFormAdapter {
  
  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'voucher-channel-user', dataApiName: 'VoucherMessageChannelUser', text: 'Superbrugere',
        primaryKey: 'id', titleFields: ['id'], baseFields: ['id', 'history']
      },
      fieldMetadata: [
        { name: 'channelId', text: 'Kanal', tooltipText: 'Bilagskanal', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'name', foreignKeyTableName: 'VoucherMessageChannel' },
        { name: 'userId', text: 'Bruger', tooltipText: 'Bruger', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'name', foreignKeyTableName: 'User', foreignKeyTableParams: ['$filterSystemRows'] },
        { name: 'primary', text: 'Primær', tooltipText: 'Primær kanal', allowEdit: true, defaultValue: '', allowEditOnAdd: true, format: 'CheckBox' },
        { name: 'admin', text: 'Synkroniser', tooltipText: 'Kan synkronisere', allowEdit: true, allowEditOnAdd: true, format: 'CheckBox' },
        { name: 'ledgerJournalName', text: 'Finanskladde', tooltipText: 'Finanskladde som bilag placeres i', foreignKeyTableName: 'FinanceLedgerJournalName', foreignKeyField: 'num' }
      ]
    });
  }
}
